import React, {Component} from 'react';
import { connect } from 'react-redux';
import {updateInfo,getNewStates} from '../actions';


class InputField extends Component {

	constructor( props ) {
		super( props );
		this.checkShowHiddenField();
		this.handleChange = this.handleChange.bind( this );
		this.handleChangeCheckBox = this.handleChangeCheckBox.bind( this );
		this.state = {
			checkedItems   : this.props.preselected,
			checkAll       : false,
			checkNone      : false,
			showTechSub    : true,
			showHiddenField: this.checkShowHiddenField(),
			preSelectedDone: false
		};
		if ( this.state.checkedItems !== [] ) {
			let userInfo = this.props.userInfo;
			userInfo[ this.props.id ] = this.state.checkedItems;
			this.props.updateInfo( userInfo );
		}

	}

	checkShowHiddenField(){
		if(typeof this.props.show_hidden_text_box_on_select !== 'undefined'){
			if(this.props.preselected.includes(this.props.show_hidden_text_box_on_select)){
				return true;
			} else{
				return false;
			}
		} else{
			return false;
		}
	}

	checkAllOptions( objArr ) {
		const options = objArr.map( ( option ) => {
			if ( option[ 0 ] === 'NA' ) {
				return (<div>
						<input type="checkbox" class="form-control" value={ option[ 0 ] } disabled={ 'disabled' }></input><label>{ option[ 1 ] }</label>
					</div>
				)
			} else {
				if ( option[ 0 ] === 'TI' ) {
					return this.getTechnologyOptions( option[ 0 ], option[ 1 ], true );
				} else {
					return (<div>
							<input type="checkbox" class="form-control" value={ option[ 0 ] } onChange={ this.handleChangeCheckBox } checked={ 'checked' }></input><label>{ option[ 1 ] }</label>
						</div>
					);
				}
			}
		} );
		return options;
	}

	checkNone( objArr ) {
		const options = objArr.map( ( option ) => {
			if ( option[ 0 ] === 'NA' ) {

				return (<div>
						<input type="checkbox" class="form-control" value={ option[ 0 ] } onChange={ this.handleChangeCheckBox } checked={ 'checked' }></input><label>{ option[ 1 ] }</label>
					</div>
				);
			} else {
				if ( option[ 0 ] === 'TI' ) {
					return this.getTechnologyOptions( option[ 0 ], option[ 1 ], false, true );
				}
				if(option[0] === this.props.show_hidden_text_box_on_select){
					showHiddenField
				}
				return (<div>
						<input type="checkbox" class="form-control" value={ option[ 0 ] } disabled={ 'disabled' } checked={ false }></input><label>{ option[ 1 ] }</label>
					</div>
				);
			}
		} );
		return options;
	}

	showHiddenField() {
		if ( this.state.showHiddenField === false ) {
			return true;
		} else {
			return false;
		}
	}


	checkOtherOption( option ) {
		if ( typeof this.props.show_hidden_text_box_on_select !== 'undefined' ) {
			if(option === this.props.show_hidden_text_box_on_select && this.state/show){
				this.showHiddenField()
			}
		}
	}

	regularOptions(objArr) {
		const options = objArr.map( ( option ) => {
			if ( option[ 0 ] === 'TI' && this.state.showTechSub === true ) {
				return this.getTechnologyOptions( option[ 0 ], option[ 1 ] );
			} else {
				if ( this.props.preselected.includes( option[ 0 ] ) && this.state.preSelectedDone === false ) {
						return (
							<div>
								<input type="checkbox" class="form-control" value={ option[ 0 ] } onChange={ this.handleChangeCheckBox } checked={ 'checked' }></input><label>{ option[ 1 ] }</label>
							</div>
						)
					} else {
					return (  <div>
							<input type="checkbox" class="form-control" value={ option[ 0 ] } onChange={ this.handleChangeCheckBox }></input><label>{ option[ 1 ] }</label>
						</div>
					);
				}

			}
		} );


		return options;
	}

	handleChange(event){
		let userInfo = this.props.userInfo;
		userInfo[this.props.id] = event.target.value;

		this.props.updateInfo(userInfo);
		//check if country.
		if(this.props.id === 'country'){
			//get new state
			this.props.getNewStates(event.target.value);
		}
		//check if state.
		if(this.props.id === 'state'){

			userInfo['state_name'] = event.target[1].text;
			this.props.updateInfo(userInfo);
		}
	}

	handleTechChange(){
			if(this.state.showTechSub === false){
				return true;
			} else{
				return false;
			}
	}

	handleChangeTextBox(event){
		let newState = state;
		let userInfo = this.props.userInfo;
		userInfo['conference_other_text'] = event.target.value;
		newState.userInfo = userInfo;
		this.props.updateInfo(userInfo);
		this.setState(newState);
	}

	handleChangeCheckBox(event){
		const newItem = event.target.value;
		let userInfo = this.props.userInfo;
		let showHiddenField = this.state.showHiddenField;
		if(typeof this.props.show_hidden_text_box_on_select !== 'undefined'){
			if(newItem === this.props.show_hidden_text_box_on_select){
				showHiddenField = this.showHiddenField();
			}
		}
		if(newItem === 'ALL'){
			let newCheckAll = (this.state.checkAll === true) ? false : true;
			if(newCheckAll === true){
				let checkedDefaultItems = this.checkAllItems(this);
				if(typeof this.props.special_arr !== 'undefined'){
					let objArr = Object.entries(this.props.special_arr);
					let checkedSpecialItems = objArr.map((option => option[0]));
					userInfo[this.props.id] = checkedDefaultItems.concat(checkedSpecialItems);
				} else{
					userInfo[this.props.id] = checkedDefaultItems
				}
			} else{
				userInfo[this.props.id] = [];
			}
			this.props.updateInfo(userInfo);

			this.setState({
				              checkedItems : userInfo[this.props.id],
											checkAll     : newCheckAll,
				              showHiddenField:showHiddenField
			              });
		} else if(newItem === 'NA') {

			let newCheckNone = (this.state.checkNone === true) ? false : true;

			if(newCheckNone === false){
				userInfo[this.props.id] = [];
			} else{
				userInfo[this.props.id] = ['NA'];
			}
			this.props.updateInfo(userInfo);
			this.setState({
				              checkedItems : userInfo[this.props.id],
				              checkNone     : newCheckNone,
				              showHiddenField:showHiddenField
			              });
		} else{
			const newState    = this.state;
			const checkedItems = this.state.checkedItems;
			const indexOfItem = checkedItems.indexOf( newItem );

			if ( indexOfItem > -1 ) {
				checkedItems.splice( indexOfItem, 1 );
			} else {
				checkedItems.push( newItem );
			}
			userInfo[ this.props.id ] = checkedItems;
			newState.checkedItems = checkedItems;
			newState.showHiddenField = showHiddenField;
			this.props.updateInfo( userInfo );
			this.setState( newState );
		}
	}

	checkAllItems(obj){
		if(typeof obj.props.options === 'undefined'){
				return [];
		}
		let objArr = Object.entries(obj.props.options);
		let checked_items = objArr.map(option => option[0]);
		return checked_items;
	}


	getHelpText(){
		const helpText = this.props.helpText;
		let helpHtml   = '';
		if(helpText !== ''){
			helpHtml = (<div class="help-block">{helpText}</div>);
		}
		return helpHtml;
	}

	getDisabled(){
		let disabled  = '';
		if(typeof this.props.disabled !== 'undefined'){
			disabled = this.props.disabled;
		}
		return disabled;
	}


	getSelect(id,name){

		const options = [(<option value=''>---</option>)];
		const selected_option = (typeof this.props.selected_option === 'undefined') ? false : this.props.selected_option;
		if(typeof this.props.options !== 'undefined'){
			let objArr = Object.entries(this.props.options);
			options.push(objArr.map(option => {
				if(option[0] === selected_option){
					return (<option value={option[0]} selected={'selected'} data-name={option[1]}>{option[1]}</option>)
				} else{
					return (<option value={option[0]} data-name={option[1]}>{option[1]}</option>)
				}
			}));
		}
		return(
			<div className="form-group">
				<label for={id}>{name}</label>
				<select className='form-control' id={id} name={name} disabled={this.getDisabled()} onChange={this.handleChange} >
					{options}
				</select>
				{this.getHelpText()}
			</div>
		);
	}

	getSpecialOptions(checked, disabled = false){
		let objArr = Object.entries(this.props.special_arr);
		let options = objArr.map((option) => {
			if ( this.props.preselected.includes( option[ 0 ] ) ) {
				return (<div>
					<input type="checkbox" class="form-control sub-category-input" onChange={ this.handleChangeCheckBox } value={ option[ 0 ] } checked={ true } disabled={ disabled }></input><label className={ 'sub-category-label' }>{ option[ 1 ] }</label>
				</div>
				);
			}
			if(checked !== null){
				return (<div><input type="checkbox" class="form-control sub-category-input" onChange={this.handleChangeCheckBox} value={option[0]} checked={checked} disabled={disabled}></input><label className={'sub-category-label'}>{option[1]}</label></div>)
			} else{
				return (<div><input type="checkbox" class="form-control sub-category-input" onChange={this.handleChangeCheckBox} value={option[0]} disabled={disabled}></input><label className={'sub-category-label'}>{option[1]}</label></div>)

			}
		});
		return options;
	}

	getTechnologyOptions(option1,option2, checked = null, disabled = false){
		if(option1 === 'TI'){
			let inputField = (<input type="checkbox" class="form-control" value={ option1 } onChange={ this.handleChangeCheckBox } disabled={ disabled }/>);
			if(checked !== null){
				inputField = (<input type="checkbox" class="form-control" value={option1} onChange={this.handleChangeCheckBox} disabled={disabled} checked={checked} />)
			}
			if(this.props.preselected.includes(option1)){
				inputField = (<input type="checkbox" class="form-control" value={option1} onChange={this.handleChangeCheckBox} disabled={disabled} checked={true} />)
			}
				return (<div>
					<div>{inputField}<label>{option2}</label></div>
					{this.getSpecialOptions(checked, disabled)}
				</div>);
			}
		}

	getOptions(){
		let options = [];

		if(typeof this.props.options !== 'undefined'){
			let objArr = Object.entries(this.props.options);
			if(this.state.checkAll === true){
				options = this.checkAllOptions(objArr);
			} else if(this.state.checkNone === true) {
				options = this.checkNone(objArr);
			} else{
				options = this.regularOptions(objArr);
				if(this.state.preSelectedDone === false){
					this.setState({preSelectedDone:true});
				}
			}

			if(this.state.showHiddenField === true){
				options.push(this.getTextBox());
			}
			return options;
		} else{
			return (<div></div>);
		}
	}

	getTextBox(){
		let text = (typeof this.props.userInfo['conference_other_text'] !== 'undefined') ? this.props.userInfo['conference_other_text'] : getConferenceAgendaTopicOther();
		return (<div>
			<label htmlFor="other-text" id="other-text-label">Please Specify</label>
			<textarea class="form-group" id='other-text' onChange={this.handleChangeTextBox.bind(this)} value={text} ></textarea>

		</div>);

	}



	getCheckBox(id,name, description){
		let options = this.getOptions();
		let descriptionHtml = '';
		let checked = '';

		if(description !== ''){
			descriptionHtml = (<div><label>{description}</label></div>);
		}
		return(
			<div className="form-group">
				<label for={id}>{name}</label>
				{descriptionHtml}
				<div className='checkbox'>
					{options}
				</div>
				{this.getHelpText()}
			</div>
		);
	}

	render(){
		const id   = this.props.id;
		const name = this.props.name;
		const type = this.props.type;
		let description = '';


		let maxlength = '';
		let value     = '';


		if(typeof this.props.maxlength !== 'undefined'){
			maxlength = this.props.maxlength;
		}
		if(typeof this.props.value !== 'undefined'){
			value = this.props.value;
		}
		if(typeof this.props.description !== 'undefined'){
			description = this.props.description;
		}

		if(this.props.type === 'select'){
			return(this.getSelect(id,name, description));
		}

		else if(this.props.type === 'checkbox'){
			return(this.getCheckBox(id,name, description));
		} else{

				return(
					<div className="form-group">
						<label for={id}>{name}</label>
						<input className="form-control" type={type}
						       id={id} name={name} disabled={this.getDisabled()}
						       onChange={this.handleChange}
						       placeholder={this.props.placeholder}
						       defaultValue={value}
						       maxlength={maxlength}/>
						{this.getHelpText()}
					</div>
				);

		}




	}


}

function mapStateToProps( { userInfo } ) {
	return {
		userInfo
	};
}

export default connect (mapStateToProps, {updateInfo,getNewStates})(InputField);
